import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

export default function Navbar() {
  const { logout, isAdmin } = useAuth();
  const { lang, langCode, switchLang } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const L = lang.nav;

  const links = [
    { path: "/dashboard", label: L.dashboard },
    { path: "/screening", label: L.screening },
    { path: "/rapoarte",  label: L.reports   },
    { path: "/pricing",   label: L.pricing   },
    { path: "/cont",      label: L.account   },
    ...(isAdmin ? [{ path: "/admin", label: L.admin }] : []),
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{
      background: "#1d4ed8",
      padding: "0 20px",
      display: "flex",
      alignItems: "center",
      height: 52,
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 50,
    }}>

      {/* Logo */}
      <div
        onClick={() => navigate("/dashboard")}
        style={{ marginRight: "auto", cursor: "pointer", display: "flex", alignItems: "baseline", gap: 6 }}
      >
        <span style={{ fontWeight: 700, fontSize: 16, color: "#fff", fontFamily: "Georgia, serif" }}>Narratiq</span>
        <span style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", fontFamily: "sans-serif" }}>EditorialAI</span>
      </div>

      {/* Links */}
      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
        {links.map(link => (
          <button
            key={link.path}
            onClick={() => navigate(link.path)}
            style={{
              padding: "0 12px",
              height: 52,
              background: "none",
              border: "none",
              borderBottom: isActive(link.path) ? "2px solid #fff" : "2px solid transparent",
              color: isActive(link.path) ? "#fff" : "rgba(255,255,255,0.65)",
              fontSize: 13,
              fontWeight: isActive(link.path) ? 600 : 400,
              cursor: "pointer",
              fontFamily: "sans-serif",
            }}
          >
            {link.label}
          </button>
        ))}
      </div>

      {/* Lang + logout */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: 16 }}>
        {["ro", "en"].map(code => (
          <button
            key={code}
            onClick={() => switchLang(code)}
            style={{
              padding: "3px 8px",
              border: "0.5px solid rgba(255,255,255,0.3)",
              borderRadius: 5,
              background: langCode === code ? "rgba(255,255,255,0.2)" : "transparent",
              color: "#fff",
              fontSize: 11,
              cursor: "pointer",
              fontFamily: "sans-serif",
            }}
          >
            {code.toUpperCase()}
          </button>
        ))}
        <button
          onClick={() => { logout(); navigate("/login"); }}
          style={{
            padding: "5px 12px",
            background: "rgba(255,255,255,0.1)",
            border: "0.5px solid rgba(255,255,255,0.2)",
            borderRadius: 6,
            color: "#fff",
            fontSize: 12,
            cursor: "pointer",
            fontFamily: "sans-serif",
            marginLeft: 4,
          }}
        >
          {L.logout}
        </button>
      </div>
    </nav>
  );
}
